import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CorrespondenceCompanyStoreActions,
  CorrespondenceCompanyStoreSelectors,
  CorrespondenceCompanyStoreReducer,
} from './index';
import { CorrespondenceCompanyDto } from '@cradua/data';

@Injectable()
export class CorrespondenceCompanyFacade {
  constructor(
    private store: Store<
      CorrespondenceCompanyStoreReducer.CorrespondenceCompanyPartialState
    >
  ) {}

  correspondenceCompany$ = this.store.select(
    CorrespondenceCompanyStoreSelectors.getSelected
  );
  correspondenceCompanyError$ = this.store.select(
    CorrespondenceCompanyStoreSelectors.getCorrespondenceCompanyError
  );

  getselected() {
    return this.store.select(CorrespondenceCompanyStoreSelectors.getSelected);
  }

  get isLoadingCorrespondenceCompany() {
    this.store.dispatch(
      CorrespondenceCompanyStoreActions.loadCorrespondenceCompany()
    );
    return this.store.select(
      CorrespondenceCompanyStoreSelectors.loadingCorrespondenceCompany
    );
  }

  get loadCorrespondenceCompany() {
    this.store.dispatch(
      CorrespondenceCompanyStoreActions.loadCorrespondenceCompany()
    );
    return this.store.select(
      CorrespondenceCompanyStoreSelectors.getAllCorrespondenceCompany
    );
  }

  addCorrespondenceCompany(
    newCorrespondenceCompany: CorrespondenceCompanyDto[]
  ) {
    this.store.dispatch(
      CorrespondenceCompanyStoreActions.addCorrespondenceCompany({
        newCorrespondenceCompany,
      })
    );
  }

  updateCorrespondenceCompany(
    updateCorrespondenceCompany: CorrespondenceCompanyDto[]
  ) {
    this.store.dispatch(
      CorrespondenceCompanyStoreActions.updateCorrespondenceCompany({
        updateCorrespondenceCompany,
      })
    );
  }

  removeCorrespondenceCompany(ids: string[]) {
    this.store.dispatch(
      CorrespondenceCompanyStoreActions.removeCorrespondenceCompany({ ids })
    );
  }
}
